import React, { useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"

export default function CreateGallery() {
    let [data, setData] = useState({
        name:"",
        pic:"",
        
    })
    let [getData,setGetData]= useState()
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
        name: "Room Type Name  is Required",
    pic: "Pic  is Required",
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    // let value =e.target.files? e.target.files[0]:e.target.value;
    let value = e.target.files ? e.target?.files: e.target.value;
    
    if(name ==="name" || name==="pic" ){
     setErrorMessage((old)=>{
      return{
        ...old,
      [name]:e.target.files ?imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
  }









  
  
}

  async function postData(e){
    
    e.preventDefault()
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
    }
    else{
      let response = await fetch("http://34.228.14.188:8000/api/gallery",{
        method:"GET",
        headers:{
          "content-type":"application/json"
        }
      })
      response = await response.json()
      if(response.result ==="Done"){
        setGetData(response.data)
        let item = Array.isArray(getData) ? getData.find((x)=> x.name.toLowerCase()===data.name.toLowerCase()  ):null
        if(item){
          setErrorMessage((old)=>{
            return{
              ...old,
              'name':"Name is Already Exits "
            }
          })
        }
        else{


           let formData = new FormData()
           formData.append("name", data.name)
           formData.append("pic", data.pic)
           Array.from(data.pic).forEach((p)=>{
            formData.append("pic" , p)
      })
          let response = await fetch ("http://34.228.14.188:8000/api/gallery",{
            method:"POST",
            body: formData
          })
          response = await response.json()
          
          if(response.result === "Done")
            navigate("/admin/gallery")
          else
           alert("something went wrong")

        }
       
      }

      else{
      }
     
    }

  }

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>CREATE GALLERY <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>
                           
                       </div>
                     <form  onSubmit={postData}>
                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Room  Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      
                    </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Pic*</label>
                        <input type="file" name='pic' onChange={getInputData} multiple className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                    
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>CREATE</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
